import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FiHome,
  FiCalendar,
  FiFileText,
  FiMapPin,
  FiMap,
  FiClipboard,
  FiDatabase,
  FiMail,
  FiDownload,
  FiUnlock,
} from 'react-icons/fi';
import { useMenu } from '../../context/MenuContext';
import './Sidebar.css';

// Map route path to icon component for dynamic menu items
const pathToIcon = {
  '/dashboard': FiHome,
  '/pm-dashboard': FiCalendar,
  '/sitefeasible': FiMap,
  '/sitefeasible/sts-lp-import': FiMap,
  '/sites': FiMapPin,
  '/planner': FiCalendar,
  '/visits': FiCalendar,
  '/unlock-transactions': FiUnlock,
  '/mail-management': FiMail,
  '/visit-letters': FiDownload,
  '/reports': FiFileText,
  '/crf': FiClipboard,
  '/crf/management': FiFileText,
  '/test-data': FiDatabase,
};
const defaultIcon = FiFileText;

const pathMatches = (pathname, operationPath) =>
  pathname === operationPath || pathname.startsWith(`${operationPath}/`);

const getLongestMatchingPath = (pathname, paths) => {
  const matches = paths.filter((p) => pathMatches(pathname, p));
  if (matches.length === 0) return null;
  return matches.sort((a, b) => b.length - a.length)[0];
};

const Sidebar = ({ isOpen = false }) => {
  const location = useLocation();
  const { menuSections, loading, error } = useMenu();

  const getIcon = (path) => {
    if (!path) return defaultIcon;
    const key = getLongestMatchingPath(path, Object.keys(pathToIcon));
    return key ? pathToIcon[key] : defaultIcon;
  };

  return (
    <>
      <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon">📋</div>
            {isOpen && (
              <div className="logo-text">
                <h1>STT- Smart Trial Tracker</h1>
              </div>
            )}
          </div>
        </div>

        <nav className="sidebar-nav">
          {loading && (
            <div className="nav-section">
              {isOpen && <div className="nav-section-title">Loading menu…</div>}
            </div>
          )}
          {!loading && error && (
            <div className="nav-section">
              {isOpen && <div className="nav-section-title nav-error">{error}</div>}
              <Link to="/dashboard" className="nav-item">
                <FiHome className="nav-icon" size={20} />
                {isOpen && <span className="nav-label">Dashboard</span>}
              </Link>
            </div>
          )}
          {!loading && !error && menuSections.length === 0 && !loading && (
            <div className="nav-section">
              {isOpen && <div className="nav-section-title">No menu assigned</div>}
              <Link to="/dashboard" className="nav-item">
                <FiHome className="nav-icon" size={20} />
                {isOpen && <span className="nav-label">Dashboard</span>}
              </Link>
            </div>
          )}
          {!loading && !error && menuSections.length > 0 &&
            menuSections.map((section) => {
              const menuItems = (section.children || []).filter((item) => item.operationPath);
              const menuPaths = menuItems.map((item) => item.operationPath);
              const activePath = getLongestMatchingPath(location.pathname, menuPaths);

              return (
              <div key={section.operationCode} className="nav-section">
                {isOpen && (
                  <div className="nav-section-title">{section.operationName}</div>
                )}
                {menuItems.map((item) => {
                    const path = item.operationPath;
                    const Icon = getIcon(path);
                    const isActive = activePath === path;
                    return (
                      <Link
                        key={item.operationCode}
                        to={path}
                        className={`nav-item ${isActive ? 'active' : ''}`}
                        title={!isOpen ? item.operationName : undefined}
                      >
                        <Icon className="nav-icon" size={20} />
                        {isOpen && <span className="nav-label">{item.operationName}</span>}
                      </Link>
                    );
                  })}
              </div>
              );
            })}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
